angular.module('natura').directive('appMap', [function () {
    return {
        restrict: "E",
        scope: {
            "map": "=",
            "type": "="
        },
        controller: function () { },
        controllerAs: "ctrl",
        bindToController: true,
        templateUrl: 'assets/terkep/app/map/map.html'
    };
}]);

angular.module('natura').provider(
    "pggLayerProvider", [function () {
        /**
         * CONFIG
         */
        var config = {
            zMax: 0
        };

        this.$get = [
            "pggConfigProvider",
            "pggMapProvider",
            function (pggConfigProvider, pggMapProvider) {
                /**
                 * GETTERS AND SETTERS
                 */
                var _getZMax = function () {
                    return config.zMax;
                };
                var _setZMax = function (zMax) {
                    config.zMax = zMax;
                };
                var _getNextZMax = function () {
                    return config.zMax + 1;
                };
                /**
                 * FUNCTIONS
                 */
                var _createNaturaGeoserverLayer = function (options) {
                    var source = new ol.source.TileWMS({
                        url: options.url,
                        params: {
                            'LAYERS': options.layername,
                            'TILED': options.tiled
                        }
                    });
                    // amennyiben van cql_filter, azt is adja hozzá utólag
                    if (options.cql_filter !== "") {
                        source.updateParams({
                            "CQL_FILTER": options.cql_filter
                        });
                    }
                    return new ol.layer.Tile({
                        name: options.name,
                        baseLayer: options.isBaseLayer,
                        visible: options.isVisible,
                        legendGraphic: options.isLegendGraphic,
                        reloadable: options.isReloadable,
                        opacity: options.opacity,
                        source: source
                    });
                };

                var _createFomiLayer = function (options) {
                    var source = new ol.source.TileWMS({
                        url: options.url,
                        params: {
                            'LAYERS': options.layername,
                            'TILED': options.tiled
                        }
                    });
                    return new ol.layer.Tile({
                        name: options.name,
                        baseLayer: options.isBaseLayer,
                        visible: options.isVisible,
                        legendGraphic: options.isLegendGraphic,
                        reloadable: options.isReloadable,
                        opacity: options.opacity,
                        source: source
                    });
                };

                var _createNaturaGeoserverWfsLayer = function (options) {
                    var editUrl = pggConfigProvider.getWfsUrl() + '&service=WFS&' +
                        'version=1.1.0&request=GetFeature&typename=' + options.typeName + '&' + 'outputFormat=' +
                        options.outputFormat + '&format_options=callback:loadNaturaWfsFeatures&srsname=' + options.srsName;
                    var wfsSource = new ol.source.Vector({
                        loader: function (extent, resolution, projection) {
                            var url = editUrl + '&CQL_FILTER=' + options.cqlFilter + ' and bbox(' + options.geomColumn + ', ' +
                                extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3] + '))';
                            $.ajax({
                                url: url,
                                dataType: 'jsonp',
                                jsonp: false
                            });
                        },
                        strategy: ol.loadingstrategy.tile(ol.tilegrid.createXYZ({
                            maxZoom: 19
                        }))
                    });
                    var geojsonFormat = new ol.format.GeoJSON();
                    var ids = [];
                    window.loadNaturaWfsFeatures = function (response) {
                        /**
                         * Workaround: in case of a postgis view, the geoserver wfs does
                         * not know about spatial indexes and therefore an element can
                         * be downloaded several times. To make it right we have to make
                         * sure an element is only added once.
                         */
                        var features = geojsonFormat.readFeatures(response);
                        angular.forEach(features, function (feature) {
                            var id = feature.getProperties().id;
                            if (ids.indexOf(id) == -1) {
                                ids.push(id);
                                wfsSource.addFeature(feature);
                            }
                        });
                    };
                    var editLayer = new ol.layer.Vector({
                        legendGraphic: options.legendGraphic,
                        baseLayer: options.baseLayer,
                        name: options.displayName,
                        source: wfsSource,
                        style: options.style
                    });
                    return editLayer;
                };

                var _createCachedLayer = function (options) {
                    return new ol.layer.Tile({
                        name: options.name,
                        baseLayer: options.isBaseLayer,
                        visible: options.isVisible,
                        source: new ol.source.TileWMS({
                            url: options.url,
                            params: {
                                LAYERS: options.layername,
                                SRS: options.srs,
                                FORMAT: options.format,
                                TILED: options.tiled
                            },
                            serverType: options.serverType,
                            tileGrid: options.tileGrid
                        })
                    });
                };

                var _addLayerWithZMax = function (layer, zIndex) {
                    layer.setZIndex(zIndex);
                    pggMapProvider.getMap().addLayer(layer);
                    angular.forEach(pggMapProvider.getMap().getLayers(), function (lyr) {
                        lyr.zIndex = lyr.getZIndex();
                    });
                    _setZMax(zIndex);
                };

                /**
                 * RETURNS
                 */
                return {
                    createNaturaGeoserverLayer: _createNaturaGeoserverLayer,
                    createNaturaGeoserverWfsLayer: _createNaturaGeoserverWfsLayer,
                    createFomiLayer: _createFomiLayer,
                    createCachedLayer: _createCachedLayer,
                    getZMax: _getZMax,
                    addLayerWithZMax: _addLayerWithZMax,
                    getNextZMax: _getNextZMax
                };
            }
        ];
    }]);

angular.module('natura').provider("pggMapProvider", [function () {
    /**
     * CONFIG
     */
    var config = {
        map: null,
        bbox: [420000, 40000, 950000, 370000]
    };
    this.$get = [function () {
        /***************************************************************************
         * GETTERS AND SETTERS
         **************************************************************************/
        var _getMap = function () {
            return config.map;
        };
        var _setMap = function (map) {
            config.map = map;
        };
        var _getBbox = function () {
            return config.bbox;
        };
        var _setBbox = function (bbox) {
            config.bbox = bbox;
        };
        /***************************************************************************
         * Functions
         **************************************************************************/
        var _zoomToExtent = function (bbox) {
            config.map.getView().fit(bbox, config.map.getSize());
        };
        /***************************************************************************
         * RETURNS
         **************************************************************************/
        return {
            getMap: _getMap,
            setMap: _setMap,
            getBbox: _getBbox,
            setBbox: _setBbox,
            zoomToExtent: _zoomToExtent
        };
    }];
}]);

angular.module('natura').controller(
    'MainController', [
        '$scope',
        'pggConfigProvider',
        'pggMapProvider',
        'pggLayerProvider',
        'pggStyleProvider',
        'pggScaleProvider',
        'pggInteractionsProvider',
        'pggEditProvider',
        function ($scope, pggConfigProvider, pggMapProvider, pggLayerProvider, pggStyleProvider, pggScaleProvider,
            pggInteractionsProvider, pggEditProvider) {
            // EOV hozzáadása
            proj4.defs("EPSG:23700", "+proj=somerc +lat_0=47.14439372222222 +lon_0=19.04857177777778 " +
                "+k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +units=m +no_defs");

            // paraméterek beállítása
            // userid beállítása, egy beégetett változóból szedi ki
            // (main.blade.php)
            if (userID !== 0 && observedID !== 0 && observedID != userID) {
                // TODO
                // a megfigyelt felhasználó adatait lássa...
                pggEditProvider.setUserId(observedID);
                // ...de tudjuk, hogy ő egy admin user, vagyis ne legyen módosítási
                // joga
                pggEditProvider.setUserCanEdit(false);
            } else {
                pggEditProvider.setUserId(userID);
                pggEditProvider.setUserCanEdit(true);
            }

            switch (window.location.hostname) {
                case "natura.lan":
                    pggConfigProvider.setKornyezet("local");
                    pggConfigProvider.setProxyUrl("http://localhost:8080/naturaproxy");
                    pggConfigProvider.setGeoserverUrl(pggConfigProvider.getProxyUrl() + "/wmsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setFomiProxyUrl(pggConfigProvider.getProxyUrl() + "/fomiproxy");
                    pggConfigProvider.setWfsUrl(pggConfigProvider.getProxyUrl() + "/wfsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setOsmCacheUrl(pggConfigProvider.getProxyUrl() + "/osmcacheproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setPrintUrl("printproxy?location=" + window.location.hostname);
                    break;
                case "natura2000-fejlesztoi.lechnerkozpont.hu":
                    pggConfigProvider.setKornyezet("fejlesztoi");
                    pggConfigProvider.setProxyUrl("http://natura2000-fejlesztoi.lechnerkozpont.hu:8080/naturaproxy");
                    pggConfigProvider
                        .setGeoserverUrl(pggConfigProvider.getProxyUrl() + "/wmsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setFomiProxyUrl(pggConfigProvider.getProxyUrl() + "/fomiproxy");
                    pggConfigProvider
                        .setWfsUrl(pggConfigProvider.getProxyUrl() + "/wfsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setOsmCacheUrl(pggConfigProvider.getProxyUrl() + "/osmcacheproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setPrintUrl("printproxy?location=" + window.location.hostname);
                    break;
                case "natura2000-teszt.lechnerkozpont.hu":
                    pggConfigProvider.setKornyezet("teszt");
                    pggConfigProvider.setProxyUrl("http://natura2000-teszt.lechnerkozpont.hu/naturaproxy");
                    pggConfigProvider
                        .setGeoserverUrl(pggConfigProvider.getProxyUrl() + "/wmsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setFomiProxyUrl(pggConfigProvider.getProxyUrl() + "/fomiproxy");
                    pggConfigProvider.setWfsUrl(pggConfigProvider.getProxyUrl() + "/wfsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setOsmCacheUrl(pggConfigProvider.getProxyUrl() + "/osmcacheproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setPrintUrl(pggConfigProvider.getProxyUrl() + "/printproxy?location=" +
                        window.location.hostname);
                    break;
                case "natura2000-eles.lechnerkozpont.hu":
                    pggConfigProvider.setKornyezet("eles_belso");
                    pggConfigProvider.setProxyUrl("http://natura2000-eles.lechnerkozpont.hu:8080/naturaproxy");
                    pggConfigProvider.setGeoserverUrl(pggConfigProvider.getProxyUrl() + "/wmsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setFomiProxyUrl(pggConfigProvider.getProxyUrl() + "/fomiproxy");
                    pggConfigProvider.setWfsUrl(pggConfigProvider.getProxyUrl() + "/wfsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setOsmCacheUrl(pggConfigProvider.getProxyUrl() + "/osmcacheproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setPrintUrl(pggConfigProvider.getProxyUrl() + "/printproxy?location=" +
                        window.location.hostname);
                    break;
                case "naturaterv.hu":
                    pggConfigProvider.setKornyezet("eles");
                    pggConfigProvider.setProxyUrl("http://naturaterv.hu/naturaproxy");
                    pggConfigProvider.setGeoserverUrl(pggConfigProvider.getProxyUrl() + "/wmsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setFomiProxyUrl(pggConfigProvider.getProxyUrl() + "/fomiproxy");
                    pggConfigProvider.setWfsUrl(pggConfigProvider.getProxyUrl() + "/wfsproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setOsmCacheUrl(pggConfigProvider.getProxyUrl() + "/osmcacheproxy?location=" +
                        window.location.hostname);
                    pggConfigProvider.setPrintUrl(pggConfigProvider.getProxyUrl() + "/printproxy?location=" +
                        window.location.hostname);
                    break;
                default:
                    break;
            }

            // control-ok létrehozása
            var myFormat = function (dgts) {
                return (function (coord1) {
                    return "&nbsp;EOV " + ol.coordinate.toStringXY(coord1, dgts) + "&nbsp;";
                });
            };
            var mousePositionControl = new ol.control.MousePosition({
                coordinateFormat: myFormat(1),
                projection: pggConfigProvider.getSrs()
            });
            var scaleLineControl = new ol.control.ScaleLine();

            // térkép létrehozása
            this.map = new ol.Map({
                layers: [],
                target: 'map',
                renderer: 'canvas',
                interactions: pggInteractionsProvider.getDefaultInteractions(),
                controls: ol.control.defaults({
                    attributionOptions: ({
                        collapsible: true
                    })
                }).extend([mousePositionControl, scaleLineControl]),
                view: new ol.View({
                    projection: pggConfigProvider.getSrs(),
                    center: [660260, 167493],
                    zoom: 6,
                    resolutions: pggScaleProvider.getResolutions()
                }),
                loadTilesWhileAnimating: true,
                loadTilesWhileInteracting: true
            });

            pggInteractionsProvider.setDefaultInteraction(ol.interaction.DoubleClickZoom, false);
            $scope.map = this.map;
            pggMapProvider.setMap(this.map);


            var tileGridOsm = new ol.tilegrid.TileGrid({
                extent: [421306.58134742436, 43986.223614953604, 994746.5813474243, 617426.2236149536],
                resolutions: [1120.0, 560.0, 280.0, 140.0, 55.99999999999999, 27.999999999999996, 13.999999999999998,
                    6.999999999999999, 2.8, 1.4, 0.5599999999999999, 0.27999999999999997, 0.13999999999999999,
                    0.06999999999999999, 0.027999999999999997],
                tileSize: [256, 256]
            });

            var orto2005cache = pggLayerProvider.createCachedLayer({
                name: "Ortofotó 2005",
                isBaseLayer: true,
                url: pggConfigProvider.getOsmCacheUrl(),
                layername: "orto_labels",
                tiled: true,
                srs: pggConfigProvider.getSrs(),
                format: "image/png",
                tileGrid: tileGridOsm,
                serverType: "geoserver",
                isLegendGraphic: false,
                isVisible: true,
                opacity: 1
            });

            // rétegek létrehozása
            var geox = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Utcatérkép",
                layername: "natura:ekozmu_basemap",
                cql_filter: "",
                isLegendGraphic: false,
                isBaseLayer: true,
                isVisible: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var orto_2015 = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Ortofotó 2015 (Kiskunság)",
                layername: "ortofoto_2015",
                cql_filter: "",
                isLegendGraphic: false,
                isBaseLayer: true,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getFomiProxyUrl(),
                tiled: true
            });

            var n2020_ke = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Régi 20 terület kezelési egységei",
                layername: "natura:n2020_ke",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var aner2004 = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Á-NÉR 2004",
                layername: "natura:n2004_aner",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var n2004_ke = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Kezelési egység (Kiskunság)",
                layername: "natura:n2004_ke",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var nemtam_kiskunsag = pggLayerProvider.createNaturaGeoserverLayer({
                name: "MEPAR nem támogatható terület",
                layername: "natura:layer_cvsak_kiskunsag_nemtam",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var natura = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Natura2000 terület",
                layername: "natura:layer_natura2000_sac,natura:layer_natura2000_spa",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var okohalo = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Országos Ökológiai Hálózat",
                layername: "natura:layer_noh_2016_03_03",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var ramsari = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Ramsari terület",
                layername: "natura:layer_ramsar_orsz_20150128",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var vedett = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Védett természeti terület",
                layername: "natura:layer_nptkttte_20160210",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: false
            });

            var naturpark = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Natúrpark",
                layername: "natura:layer_naturpark",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var geopark = pggLayerProvider.createNaturaGeoserverLayer({
                name: "Geopark",
                layername: "natura:layer_geopark",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            var mab = pggLayerProvider.createNaturaGeoserverLayer({
                name: "MAB terület",
                layername: "natura:layer_mab_orszagos_br_2013",
                cql_filter: "",
                isLegendGraphic: true,
                isBaseLayer: false,
                isVisible: false,
                isReloadable: false,
                opacity: 1,
                url: pggConfigProvider.getGeoserverUrl(),
                tiled: true
            });

            // rétegek hozzáadása a térképhez
            pggLayerProvider.addLayerWithZMax(geox, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(orto2005cache, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(orto_2015, pggLayerProvider.getNextZMax());

            pggLayerProvider.addLayerWithZMax(aner2004, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(n2004_ke, pggLayerProvider.getNextZMax());
            // pggLayerProvider.addLayerWithZMax(n2020_ke,
            // pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(nemtam_kiskunsag, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(okohalo, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(ramsari, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(vedett, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(naturpark, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(geopark, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(mab, pggLayerProvider.getNextZMax());
            pggLayerProvider.addLayerWithZMax(natura, pggLayerProvider.getNextZMax());

        }
    ]);
